import coreApi from 'api/coreApi';
import { AxiosError } from 'axios';
import {
  GetReferralDetailRevenueResponse,
  GetMonthlyPayoutResponse,
  GetReferralRevenueResponse,
} from 'types/api/marketplace/revenue/referral';
import {
  editSellerPayoutStatus,
  getSellerPayoutStatusInfo,
} from 'api/marketplace/revenue/itemSales';
import {
  MonthYearParams,
  SellerPayoutDetailInfo,
  TotalPayoutDetailInfo,
} from 'types/marketplace/revenue';

//////////* Referral Revenue *//////////

export const getReferralRevenue = (query: string) => {
  return coreApi
    .get<GetReferralRevenueResponse>(`/connects/referral/revenue?${query}`)
    .catch((error: AxiosError<Error>) => ({ error }));
};

export const getReferralRevenueDetails = (query: string) => {
  return coreApi
    .get<GetReferralDetailRevenueResponse>(`/connects/referral/revenue/detail?${query}`)
    .catch((error: AxiosError<Error>) => ({ error }));
};

//////////* Monthly Payout *//////////
export const getSellerMonthlyPayout = (query: string) => {
  return coreApi
    .get<GetMonthlyPayoutResponse>(`/connects/referral/monthlyPayout?${query}`)
    .catch((error: AxiosError<Error>) => ({ error }));
};

export const getTotalPayoutDetail = (params: MonthYearParams) => {
  return coreApi
    .get<TotalPayoutDetailInfo>(`/connects/referral/monthlyPayout/totalDetail`, {
      params,
    })
    .catch((error: AxiosError<Error>) => ({ error }));
};

export const getSellerPayoutDetail = ({
  userId,
  year,
  month,
}: MonthYearParams & { userId: number }) => {
  return coreApi
    .get<SellerPayoutDetailInfo>(`/connects/referral/monthlyPayout/referrer/${userId}/details`, {
      params: { year, month },
    })
    .catch((error: AxiosError<Error>) => ({ error }));
};

//////////* Monthly Payout  -  Status *//////////
export const getReferralPayoutStatusInfo = getSellerPayoutStatusInfo; // ItemSales와 동일한 API이므로 재사용

export const editReferralPayoutStatus = editSellerPayoutStatus; // ItemSales와 동일한 API이므로 재사용

export const getPaypalPayoutCSV = (params: MonthYearParams) => {
  return coreApi
    .get('/connects/referral/revenue/paypalPayouts/csv', {
      params,
    })
    .catch((error: AxiosError<Error>) => ({ error }));
};

//////////* Monthly Payout  - Payout/Confirm *//////////
export const editTotalPayoutConfirm = (payload: MonthYearParams) => {
  return coreApi
    .post<SellerPayoutDetailInfo>(`/connects/referral/monthlyPayout/totalDetail/confirm`, payload)
    .catch((error: AxiosError<Error>) => ({ error }));
};

export const editTotalPayoutExecution = (payload: MonthYearParams) => {
  return coreApi
    .post<SellerPayoutDetailInfo>(`/connects/referral/monthlyPayout/totalDetail/payout`, payload)
    .catch((error: AxiosError<Error>) => ({ error }));
};

/** Test 환경에서만 QA목적으로 사용키로 진행. Reset Payout/Confirm */
export const resetPayoutConfirm = (data: MonthYearParams) => {
  return coreApi
    .delete('/connects/referral/monthlyPayout/totalDetail', { data })
    .catch((error: AxiosError<Error>) => ({ error }));
};
